module.exports = __webpack_public_path__ + "img/appreciateAgreementBackground.80cc0e86.png";